export default function eventHandler(latLng, eventName) {
  switch (eventName) {
    case 'addCamHere':
      this.props.checkOfflineLimitsAction('createCamera', [latLng])
      break
    case 'centerMapHere':
      const position = new google.maps.LatLng(latLng.lat(), latLng.lng())
      this.props.updateMapLocationAction(position)
      break
    case 'zoomToAllDevices':
      this.props.zoomToAllDevicesAction()
      break
  }
  return this.contextMenu.hide()
}



// WEBPACK FOOTER //
// ./src/helpers/map/eventHandler.js